import NumberFormat from 'react-number-format'
const THOUSAND_SEPARATOR = '.'
const DECIMAL_SEPARATOR = ','

export function textToNumberFormatting(text, decimals) {
  if (text) {
    const value = text.split('-')
    const number = parseFloat(value[0])
    const options = {
      value: number,
      displayType: 'text',
      decimalScale: decimals,
      thousandSeparator: THOUSAND_SEPARATOR, // default is comma
      decimalSeparator: DECIMAL_SEPARATOR,
      prefix: '$',
    }
    return value.length === 2 ? (
      <NumberFormat {...options} suffix={'-'} />
    ) : (
      <NumberFormat {...options} />
    )
  } else {
    return null
  }
}

// Constants for catalog lines to exclude
const EXCLUDED_CATALOG_LINES = ['Bosch Elementos', 'Bosch Válvulas', 'Bosch Toberas']

// Function to check if item has diagram
export function hasDiagram(item) {
  if (!item || !item.marcas) return false

  return item.marcas.some((brand) => {
    const isBoschDiesel = brand.descripcion === 'Bosch Diesel'
    const brandLine = brand.catalogLineDescription
    const itemLine = item.catalogLineDescription

    if (isBoschDiesel && brandLine && !EXCLUDED_CATALOG_LINES.includes(brandLine)) {
      return true
    }

    if (isBoschDiesel && itemLine && !EXCLUDED_CATALOG_LINES.includes(itemLine)) {
      return true
    }

    if (isBoschDiesel && !brandLine && !itemLine) {
      return true
    }
    return false
  })
}
